import * as React from 'react';
import { CONTEXT_PROPS } from './Types';

export const ReorderContext = React.createContext<CONTEXT_PROPS>({
  reorder: () => {},
  dragStart: () => {}
});
